<template>
  <section :id="AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS" class="offset-bottom-2 scroll_top">
    <div class="tabset-header">
      <h3>{{ $t('autotopupregistrations.details_headline') + ' ' + row.id }}</h3>
    </div>
    <transition name="fade" mode="out-in" appear>
      <div v-if="internalRow">
        <VRegistration :registration-details="internalRow" />
        <VDeregistration v-if="internalRow.status === 'DELETED'" :registration-details="internalRow" />
        <VRegistrationError v-if="internalRow.status === 'FAILED'" :error-data="errorData" />
        <VTransactions v-if="internalRow.latestTopUp" :transactions="internalRow.latestTopUp" />
      </div>
    </transition>
  </section>
</template>

<script>
import VRegistration from './Registration';
import VTransactions from './Transactions';
import VDeregistration from './Deregistration';
import VRegistrationError from './RegistrationError';
import { AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS } from '@/router/route-types';

export default {
  name: 'AutoTopUpRegistrationDetails',

  components: {
    VRegistration,
    VTransactions,
    VDeregistration,
    VRegistrationError,
  },

  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      internalRow: this.row,
    };
  },

  computed: {
    errorData() {
      return { errorStatus: this.internalRow.errorStatus, errorDetail: this.internalRow.errorDetail };
    },
  },

  watch: {
    row: 'onRowChange',
  },

  created() {
    this.AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS = AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS;
  },

  methods: {
    onRowChange(row) {
      this.internalRow = null;
      this.$nextTick(() => {
        this.internalRow = row;
      });
    },
  },
};
</script>
